module.exports = __webpack_public_path__ + "static/media/app_store.8fd45f10.svg";